import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Apple: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width={size ? size : '56'}
      height="8"
      viewBox={`0 0 ${size ? size : '56'} 8`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full"
    >
      <rect
        width={size ? size : '56'}
        height="8"
        rx="4"
        fill="#FF9D43"
        fillOpacity="0.2"
      />
    </svg>
  );
};

export default Apple;
